import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./context/I18nContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import ProjectsList from "./pages/ProjectsList";
import ProjectDetail from "./pages/ProjectDetail";
import Settings from "./pages/Settings";
import Users from "./pages/Users";
import ShareLinks from "./pages/ShareLinks";
import SharedView from "./pages/SharedView";
import WorkProgram from "./pages/WorkProgram";
import DataExplorer from "./pages/DataExplorer";

// Hoisted outside the component so it isn't reallocated on every render.
const TOAST_OPTIONS = { classNames: { toast: "font-sans" } };

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Public share routes - no auth */}
            <Route path="/share/:token" element={<SharedView />} />
            <Route path="/share/:token/iframe" element={<SharedView />} />

            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/projects" element={<ProjectsList />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/work-program" element={<WorkProgram />} />
              <Route path="/data" element={<DataExplorer />} />
              <Route path="/share-links" element={<ShareLinks />} />
              <Route path="/users" element={<Users />} />
              <Route path="/settings" element={<Settings />} />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster richColors position="top-right" toastOptions={TOAST_OPTIONS} />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
